import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { applicationSteps } from '../data/content';
import { Button } from './ui/button';

export const ApplicationSteps = () => {
  return (
    <section data-testid="application-steps" className="section-spacing bg-white relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-10 right-10 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl" />
      
      <div className="section-container relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block px-4 py-2 bg-purple-100 text-purple-600 rounded-full text-sm font-semibold mb-4">
            Easy Process
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 font-['Outfit']">
            How to <span className="text-coral">Apply</span>
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Get started in just 5 simple steps.
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-coral/20 via-coral/50 to-coral/20 -translate-y-1/2 z-0" />
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 relative z-10">
            {applicationSteps.map((step, idx) => (
              <div
                key={step.step}
                data-testid={`step-${step.step}`}
                className="bg-white rounded-2xl p-6 border border-orange-100 hover:border-coral/30 text-center relative transition-all shadow-sm hover:shadow-lg"
              >
                <div className="w-12 h-12 bg-gradient-to-r from-coral to-orange text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold font-['Outfit'] shadow-lg shadow-coral/30">
                  {step.step}
                </div>
                <h3 className="font-bold text-slate-900 font-['Outfit'] mb-2">
                  {step.title}
                </h3>
                <p className="text-slate-500 text-sm">{step.description}</p>
                
                {/* Arrow for larger screens */}
                {idx < applicationSteps.length - 1 && (
                  <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 text-coral/50">
                    <ArrowRight className="w-6 h-6" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Link to="/contact">
            <Button
              data-testid="steps-start-btn"
              className="bg-gradient-to-r from-coral to-orange hover:from-coral-dark hover:to-coral text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg shadow-coral/25"
            >
              Start Your Application
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
